<div class="info-tile" [ngClass]="{'no-bg': disableBackground}">
    <h2 class="info-value">{{ infoValue }}</h2>
    <p class="info-name">{{ infoName }}</p>
</div>
